import React, { useState, useEffect } from 'react';
import { getAccountSettings, uploadLogo, updateTheme } from '../services/settings';
import './AccountSettingsPage.css';
import { applyTheme } from '../utils/themeUtils';

const AccountSettingsPage = () => {
  const [settings, setSettings] = useState({
    logo_url: null,
    theme: {
      background_color: '#f5f5f5',
      button_color: '#000000',
      hover_color: '#333333',
    },
  });
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const data = await getAccountSettings();
      setSettings(data);
    } catch (error) {
      console.error('Error loading settings:', error);
    }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
        const result = await uploadLogo(file);
        const newSettings = { 
        ...settings, 
        logo_url: result.logo_url 
        };
        setSettings(newSettings);
        alert('Logo subido correctamente. Recuerda hacer clic en Guardar.');
    } catch (error) {
        console.error('Error uploading logo:', error);
        alert('Error al subir el logo');
    } finally {
        setUploading(false);
    }
};

  const handleThemeChange = (field, value) => {
    setSettings({
      ...settings,
      theme: {
        ...settings.theme,
        [field]: value,
      },
    });
  };

  const handleSave = async () => {
    setSaving(true);
    try {
        await updateTheme(settings.theme);
        applyTheme(settings.theme);
        alert('Configuración guardada correctamente');
    } catch (error) {
        console.error('Error saving theme:', error);
        alert('Error al guardar la configuración');
    } finally {
        setSaving(false);
    }
    };

  return (
    <div className="settings-container">
      <h1 className="settings-title">Configuración de cuenta</h1>

      <div className="settings-section">
        <h3>Logo de la empresa</h3>
        <div className="logo-upload">
          {settings.logo_url && (
            <img
              src={`${process.env.REACT_APP_API_URL}${settings.logo_url}`}
              alt="Logo"
              className="logo-preview"
            />
          )}
          <input
            type="file"
            id="logo-input"
            accept=".png,.jpg,.jpeg,.gif,.svg"
            onChange={handleLogoUpload}
            style={{ display: 'none' }}
          />
          <label htmlFor="logo-input" className="btn-import">
            {uploading ? 'Subiendo...' : 'Importar'}
          </label>
          <p className="file-info">
            Formatos permitidos: jpeg, jpg, gif, svg, png | Tamaño máximo: 5MB
          </p>
        </div>
      </div>

      <div className="settings-section">
        <h3>Aspecto</h3>
        <div className="color-picker-group">
          <div className="color-item">
            <label>Color de fondo</label>
            <input
              type="color"
              value={settings.theme?.background_color || '#f5f5f5'}
              onChange={(e) => handleThemeChange('background_color', e.target.value)}
            />
          </div>
          <div className="color-item">
            <label>Color del botón</label>
            <input
              type="color"
              value={settings.theme?.button_color || '#000000'}
              onChange={(e) => handleThemeChange('button_color', e.target.value)}
            />
          </div>
          <div className="color-item">
            <label>Color del hover</label>
            <input
              type="color"
              value={settings.theme?.hover_color || '#333333'}
              onChange={(e) => handleThemeChange('hover_color', e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="settings-actions">
        <button onClick={handleSave} disabled={saving} className="btn-save">
          {saving ? 'Guardando...' : 'Guardar'}
        </button>
        <button onClick={() => window.history.back()} className="btn-cancel">
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default AccountSettingsPage;